import React, { useState } from 'react';
import { Play, Image as ImageIcon, Globe2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface FileRowProps {
  name: string;
  thumbnail?: string | null;
  onClick: () => void;
  kind: 'images' | 'videos' | 'panos';
}

const FileRow: React.FC<FileRowProps> = ({ name, thumbnail, onClick, kind }) => {
  const { t } = useTranslation();
  const [errored, setErrored] = useState(false);
  const icon =
    kind === 'videos' ? <Play className="w-4 h-4" /> : kind === 'panos' ? <Globe2 className="w-4 h-4" /> : <ImageIcon className="w-4 h-4" />;

  const kindLabel = kind === 'panos' ? t('qr.panos') : t(`qr.${kind}`);

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-3 bg-[#1f1f1f] rounded-lg border border-transparent hover:border-[#C8102E] transition-colors text-left"
    >
      <div className="w-12 h-12 rounded-md bg-[#141414] flex items-center justify-center overflow-hidden text-[#C8102E]">
        {thumbnail && !errored ? (
          <img
            src={thumbnail}
            alt={name}
            className="w-full h-full object-cover"
            loading="lazy"
            onError={() => setErrored(true)}
          />
        ) : (
          icon
        )}
      </div>
      <div className="flex-1">
        <p className="text-[#E0E0E0] text-sm sm:text-base">{name}</p>
        <p className="text-xs text-[#888888] capitalize">{kindLabel}</p>
      </div>
    </button>
  );
};

export default FileRow;
